import React from 'react'
import ExperienceSection from '../components/ExperienceSection'
import ProjectsSection from '../components/ProjectsSection'
import About from '../components/Sidebar/About'
import Links from '../components/Sidebar/Links'

import './style.scss'

const IndexPage = () => (
    <div className="index">
      <div className="main">
        <h5>
          Hi, I'm <span className="bold">Hakim</span>
        </h5>

        <h4 className="bold">
        a software developer based in Singapore currently with Yara Digital Hub who is currently working on our FarmWeather Project. I am very passionate about the web and have professional experience with ReactJS, GatsbyJS, VueJS and Ruby on Rails.
        </h4>
        <ExperienceSection />
        <ProjectsSection />
        
      </div>

      <div className="aside">
        <div className="top">
          <About />
        </div>
        <div className="bottom">
          <Links />
        </div>
      </div>
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js